module.exports = __webpack_public_path__ + "posture/static/img/leg_x_normal.139efd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/leg_x_normal.png
// module id = T69A
// module chunks = 1